import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faBatteryEmpty, faShippingFast} from '@fortawesome/free-solid-svg-icons';
import {RunService} from 'app/blocks/service/api/run.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_RUNS_BASE_URL} from 'app/app.constants';
import {IRun, Run} from 'app/blocks/model/run.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class RunResource extends AbstractEntityResource<IRun> {
    constructor(runService: RunService, router: Router) {
        super(
            Resource.RUNS,
            runService,
            new EntityNavigator(ENTITIES_RUNS_BASE_URL, Resource.RUNS, router),
            new EntityUrlProvider(ENTITIES_RUNS_BASE_URL, Resource.RUNS),
            (entity?) => new Run(entity),
            (entity) => entity.id,
            faShippingFast
        );
    }
}
